export const PhoneNumberTest = (str) =>
  /\((\d{2})\) (\d{4,5})-(\d{4})/g.test(str);

export const PhoneNumberOutput = (str) => {
  const phone = str.trim();

  if (phone.length > 15) return phone.slice(0, 15);

  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3');
};

export const PhoneNumberParse = (str) => {
  const phone = str.trim();

  return phone.replace(/\D/g, '');
};

export const PhoneNumberDDDOutput = (str, areaCode) => {
  let DDD = areaCode ? Number(areaCode.replace(/\s/g, '')).toString() : '0';

  DDD = DDD.length === 2 ? DDD : 'XX';  

  const phone = DDD + str.trim();

  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3');
};
